import { render, staticRenderFns } from "./dataintegration.vue?vue&type=template&id=1bb969e6&scoped=true&"
import script from "./dataintegration.vue?vue&type=script&lang=ts&"
export * from "./dataintegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb969e6",
  null
  
)

export default component.exports